import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { UserMgmtFacade } from '../../views/user-management/facade/user-mgmt.facade';
import { returnUrlParams } from '../utils/return-url';

@Injectable({ providedIn: 'root' })
export class AupGuardService {
  private readonly userMgmtFacade = inject(UserMgmtFacade);
  private readonly router = inject(Router);

  canActivateChild(_childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (!this.userMgmtFacade.getCurrentUserSignal()) {
      this.userMgmtFacade.getMeUser();
    }

    // currentUser$ only emits users that /me returned in this session, so the
    // gate is never decided against a user rehydrated from a previous account.
    return this.userMgmtFacade.currentUser$.pipe(
      take(1),
      map((user) => {
        if (!user?.requires_aup_acknowledgment) {
          return true;
        }

        // Keep the page they asked for so the policy page can finish the trip.
        this.router.navigate(['/acceptable-use'], { queryParams: returnUrlParams(state.url) });
        return false;
      })
    );
  }
}
